import api from "../../../shared/api/apiClient";

export const externalApiKeysApi = {
  async list(params = {}) {
    const { data } = await api.get("/api/system/external-api-keys", {
      params,
    });
    return data;
  },

  async create(payload) {
    const { data } = await api.post("/api/system/external-api-keys", payload);
    return data;
  },

  async update(id, payload) {
    const { data } = await api.put(`/api/system/external-api-keys/${id}`, payload);
    return data;
  },

  async remove(id) {
    const { data } = await api.delete(`/api/system/external-api-keys/${id}`);
    return data;
  },

  async listUsageLogs(params = {}) {
    const { data } = await api.get("/api/system/external-api-keys/usage-logs", {
      params,
    });
    return data;
  },
};